<template>
    <EBN_Extended-component>
        <b-row>
            <b-col md="12" class="mt-3">
                <div>
                    <b-row>
                        <b-col md="4">
                            <b-form-group >
                                    <b-form-textarea v-model="searching" style="height:100px" placeholder="Type to Search : 1023,Test"  @input="checklenght(searching)"></b-form-textarea>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group label="Select Date:"  :label-cols="4" >
                                <v-date-picker mode='single' 
                                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDate'>
                               </v-date-picker>
                            </b-form-group>
                        </b-col>
                
                        <!-- <b-col md="4">
                            <b-form-group label="To Date:"  :label-cols="3" >
                                <v-date-picker mode='single' 
                                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                                </v-date-picker>
                            </b-form-group>
                        </b-col> -->

                        <b-col md="2">
                            <b-button  @click="EBNAllRecords(pageNum)"  size="md" variant="primary">Search</b-button>
                            &nbsp;
                            <b-button  @click="clearENB_extend()"    size="md" variant="danger">Clear</b-button>
                        </b-col>  
                        
                        <!-- <b-col md="6">
                            <div class="text-right">
                                <b-button   @click="downloadENB_extende()" size="md" variant="primary">Download</b-button>
                            </div>
                        </b-col> -->
                    </b-row> 
                </div>

                <div class="text-right">
                    <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
                </div>

                <b-table responsive show-empty :busy="isBusy" :items="EBN_allCount" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" :tbody-tr-class="rowClass"> 

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle">
                      </b-spinner>
                      <strong>Loading...</strong>
                    </div> 
                </b-table>
                <paginate
       
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>
            </b-col>
        </b-row>
    </EBN_Extended-component>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            isBusy: false, 
            fields: [],
            EBN_allCount :[],
            isBusy : false,
            noofpages:'',
            pageNum:1,
            searching :[],
            searchvaluesarr:[],
            totalRows :0,
            route_id : null,
            selectDate: new Date(),
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.User_type = userInfo.user_type;
        this.route_id = this.$route.params.id;

        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();

        this.EBNAllRecords(this.pageNum);
    },
    methods: {
        ischeckbodyvalidation(){
        for (let i = 0; i < this.accessBody.length; i++) {
            const element = this.accessBody[i];
        
            if (element.title=='EBN Extension' && element.isReadonly==true && this.route_id=='normal') {
            this.isReadOnly=true
            }
        if (element.child) {
            for (let j = 0; j < element.child.length; j++) {
            const k = element.child[j];
            if (k.title=='EBN Extension' && k.isReadonly==true && this.route_id=='normal') {
                this.isReadOnly=true
            }
            if (k.title=='EBN Extension' && k.isReadonly==true && this.route_id=='asn') {
                this.isReadOnly=true
            }
            
            }
        }
        }
        console.log(" this.isReadOnly", this.isReadOnly)
        },
        checklenght(value){
            console.log("value",value)
            if (value.length==0) {
            this.searching=[]
            this.totalRows=0
            this.searchvaluesarr=[]
            this.EBNAllRecords(this.pageNum)
            }
        },

        clickCallback(pageNum){

            this.EBNAllRecords(pageNum);
        },

        EBNAllRecords : function(pageNo){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            console.log("searching",this.searching.length)
            if (this.searching.length!=0) {
                var searchvalues=[];
                this.searchvaluesarr=[];
                searchvalues = this.searching.split(',')
                for (var i = 0; i < searchvalues.length; i++) {
                    this.searchvaluesarr.push(`${searchvalues[i]}`)
                }
                console.log("YYY",this.searchvaluesarr)
            }

            var fromdate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
           

            this.isBusy=true;
            if (this.route_id=='normal') {
                this.fields=[
                    // { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
                    { key: 'parentawb', label : 'Parent AWB', sortable: true},
                    { key: 'invoiceno', label : 'Load ID', sortable: true},
                    { key: 'gstinno', label : 'GST No', sortable: true},
                    { key: 'ebn', label : 'EBN', sortable: true},
                    { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
                    { key: 'error', label : 'EBN Error', sortable: true},
                    { key: 'sellergstregnumber', label : 'Seller GST No.', sortable: true},
                    { key: 'sourcecity', label : 'Source City', sortable: true},
                    { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
                    { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
                    { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                ]
            }
            
            if (this.route_id=='asn') {
                this.fields=[
                    // { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
                    { key: 'parentawb', label : 'Parent AWB', sortable: true},
                    { key: 'invoiceno', label : 'Load ID', sortable: true},
                    { key: 'gstinno', label : 'GST No', sortable: true},
                    { key: 'ebn', label : 'EBN', sortable: true},
                    { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
                    { key: 'error', label : 'EBN Error', sortable: true},
                    { key: 'sellergstregnumber', label : 'Buyer GST No.', sortable: true},
                    { key: 'sourcecity', label : 'Source City', sortable: true},
                    { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
                    { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
                    { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                    
                ]
            }

            const obj={
                page_no:`${pageNo}`,
                searchpayld:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
                is_asn: this.route_id=='normal' ? 'NO': 'YES',
                date : fromdate,
                // page_no: "1",
                // searchpayld: ["ABCDEFG121"],
                // fromDate: "2023-11-01",
                // toDate: "2023-11-31"
            }
            console.log("obj",obj)
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getallexpiredebns`,obj)
            .then(result => {
                console.log("result",result)
                this.isBusy=false;
                if (result.body.returnmsg === "successful") {
                this.EBN_allCount=result.body.returnvalue;
                console.log("EBN_allCount",this.EBN_allCount);
                this.totalRows = result.body.totalcount;  
                    console.log("HHHHH",this.totalRows); 
                this.noofpages=parseInt(this.totalRows)/20;
                console.log("this.noofpages",this.noofpages)
                this.noofpages=Math.ceil( this.noofpages);
                console.log("YYYYYY",this.noofpages)
                }else{
                    this.EBN_allCount=[];
                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        searchENB_extend(){
        
        let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
            var searchvalues=[];
            this.searchvaluesarr=[];
            searchvalues = this.searching.split(',')
            for (var i = 0; i < searchvalues.length; i++) {
                this.searchvaluesarr.push(`${searchvalues[i]}`)
            }
            console.log("YYY",this.searchvaluesarr)
            this.EBNAllRecords(this.pageNum)
        },

        clearENB_extend(){
            this.searching=[];
            this.searchvaluesarr=[];
            this.selectDate =  new Date();
            this.EBNAllRecords(this.pageNum)
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
        rowClass(item, type) {
            if(item){
            if (item.error!=null) { 
                return 'table-danger'
            }
            }
        },

        // downloadENB_extende(){
        //     // alert("i")
        //     document.getElementById("overlay").style.display = "block";
        //     var userdata = localStorage.getItem("userData");
        //     var userInfo = JSON.parse(userdata);
        //     const obj={
        //         sysusermasterid:`${userInfo.sysusermasterid}`,
        //         recordtype:this.searchvaluesarr.length>0?"search":"extended",
        //         searchpayld:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
        //         is_asn: this.route_id=='normal' ? 'NO': 'YES',
        //     }
        //     console.log("obj",obj)
        //     this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getEBNExpiryRecordsofCurrentDateCSVDownload`,obj)
        //     .then(result => {
        //         console.log("result",result)
        //         document.getElementById("overlay").style.display = "none";
        //             if(result.body=="success")
        //             {
        //             // alert("Please Check Ur Mail For Downlod Link")
        //             this.$fire({
        //                      text:"Please Check Your Mail For Downlod Link",
        //                      type: "success",
        //                      timer: 30000
        //                    });
        //         }
        //         else
        //         {
        //             // alert("Can not Download");
        //             this.$fire({
        //                      text:"Can not Download",
        //                      type: "error",
        //                      timer: 30000
        //                    });
        //         }
        //     }).catch(ex => {
        //         console.log("error", ex);
        //     });
        // },
    },
    computed: {
      rows() {
        return this.EBN_expriryCount.length
      }
    },
}
</script>
